'use client';

import { c as _c } from "react/compiler-runtime";
import { fundingAmountValidation, isHostedFundingMethod } from '@morfi/onramp-sdk';
import type { useFundingAmountDraft, useFundingInlineCheckout } from '@morfi/onramp-sdk/react';
import type { MoonPayWebProvider } from '@morfi/onramp-sdk/web';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { useFundingCardLabel } from '../shared/use-funding-card-label';
import { FundingAmount } from './amount/funding-amount';
import { FundingCheckoutFeedback } from './funding-checkout-feedback';
import { FundingLimitRecovery } from './funding-limit-recovery';
import { FundingProviderFrame } from './funding-provider-frame';
export function FundingCheckoutAmount(t0) {
  const $ = _c(57);
  const {
    checkout,
    amountDraft,
    provider
  } = t0;
  const t = useTranslations("onramp");
  const cardLabel = useFundingCardLabel(checkout.selectedCard);
  const quoteStatus = useTranslations("trade.status");
  if (!(checkout.amountEntry || checkout.method !== "card" && checkout.method !== "sepa" && checkout.paymentSignature) || !checkout.method) {
    return null;
  }
  const t1 = !checkout.amountEntry;
  let t2;
  if ($[0] !== checkout.preview.review || $[1] !== checkout.purchase) {
    t2 = checkout.purchase ? {
      purchase: checkout.purchase,
      purchaseReview: checkout.preview.review
    } : {};
    $[0] = checkout.preview.review;
    $[1] = checkout.purchase;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== cardLabel || $[4] !== checkout.method) {
    t3 = checkout.method === "card" && cardLabel ? {
      methodLabel: cardLabel
    } : {};
    $[3] = cardLabel;
    $[4] = checkout.method;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = checkout.preview.review?.estimate ?? null;
  const t5 = checkout.preview.review?.state === "indicative";
  const t6 = checkout.preview.providerFailure?.category === "connection_required";
  let t7;
  if ($[6] !== checkout) {
    t7 = checkout.preview.providerFailure?.amountBoundary ? null : fundingAmountValidation(checkout);
    $[6] = checkout;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  let t9;
  if ($[8] !== checkout) {
    t8 = <FundingCheckoutFeedback checkout={checkout} />;
    t9 = !checkout.limitRecovery.canVerify ? <FundingLimitRecovery checkout={checkout} /> : null;
    $[8] = checkout;
    $[9] = t8;
    $[10] = t9;
  } else {
    t8 = $[9];
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t8 || $[12] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== amountDraft.units || $[15] !== checkout || $[16] !== provider || $[17] !== quoteStatus || $[18] !== t) {
    t11 = checkout.method === "card" && (checkout.state === "review" || checkout.selection?.kind === "saved_card") ? <AnimatedButton className="h-11 w-full" loading={checkout.busy} disabled={checkout.busy || (checkout.state === "review" ? checkout.review?.state !== "ready" : !checkout.canContinueAmount) || checkout.limitRecovery.blocked} onClick={() => {
      if (checkout.state === "review") {
        checkout.pay();
      } else {
        if (amountDraft.units) {
          checkout.quoteAmount(amountDraft.units, true);
        }
      }
    }}>{t("pay")}</AnimatedButton> : isHostedFundingMethod(checkout.method) && checkout.attemptId ? <AnimatedButton className="h-11 w-full" loading={checkout.busy} disabled={checkout.busy} onClick={() => {
      if (checkout.amountUnits) {
        checkout.quoteAmount(checkout.amountUnits);
      }
    }}>{t("continue")}</AnimatedButton> : !isHostedFundingMethod(checkout.method) && checkout.method !== "card" && checkout.method !== "sepa" && checkout.paymentSignature && checkout.attemptId ? <div className="relative"><div className={!checkout.walletReady ? "absolute inset-0 opacity-0 pointer-events-none" : undefined} hidden={checkout.limitRecovery.blocked} inert={!checkout.paymentEnabled} aria-disabled={!checkout.paymentEnabled}><FundingProviderFrame key={checkout.attemptId} provider={provider} checkout={checkout} mode="payment" /></div>{!checkout.walletReady && !checkout.limitRecovery.blocked ? <AnimatedButton className="h-11 w-full" size="lg" disabled={true} loading={true}>{quoteStatus("loading_quote")}</AnimatedButton> : null}{checkout.limitRecovery.blocked && checkout.limitRecovery.canVerify ? <FundingLimitRecovery checkout={checkout} /> : null}{checkout.limitRecovery.blocked && !checkout.limitRecovery.canVerify ? <AnimatedButton className="h-11 w-full" size="lg" disabled={true}>{t("amount_over_limit")}</AnimatedButton> : null}</div> : checkout.limitRecovery.blocked && checkout.limitRecovery.canVerify ? <FundingLimitRecovery checkout={checkout} /> : undefined;
    $[14] = amountDraft.units;
    $[15] = checkout;
    $[16] = provider;
    $[17] = quoteStatus;
    $[18] = t;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = checkout.limitRecovery.blocked && !checkout.limitRecovery.canVerify;
  let t13;
  if ($[20] !== checkout.limitRecovery.blocked || $[21] !== checkout.method || $[22] !== checkout.paymentSignature || $[23] !== checkout.walletActionVisible) {
    t13 = checkout.method === "card" || isHostedFundingMethod(checkout.method) || !checkout.paymentSignature || checkout.limitRecovery.blocked || checkout.walletActionVisible;
    $[20] = checkout.limitRecovery.blocked;
    $[21] = checkout.method;
    $[22] = checkout.paymentSignature;
    $[23] = checkout.walletActionVisible;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const t14 = checkout.preview.state === "loading";
  const t15 = checkout.canContinueAmount && !checkout.busy;
  let t16;
  if ($[25] !== checkout) {
    t16 = units => {
      checkout.quoteAmount(units);
    };
    $[25] = checkout;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== amountDraft.setValue || $[28] !== amountDraft.value || $[29] !== checkout.amountBoundary || $[30] !== checkout.amountLocked || $[31] !== checkout.changeMethod || $[32] !== checkout.currency || $[33] !== checkout.decimals || $[34] !== checkout.displayedLimits || $[35] !== checkout.limitRecovery.blocked || $[36] !== checkout.method || $[37] !== checkout.preparingWallet || $[38] !== checkout.presets || $[39] !== checkout.previewAmount || $[40] !== t10 || $[41] !== t11 || $[42] !== t12 || $[43] !== t13 || $[44] !== t14 || $[45] !== t15 || $[46] !== t16 || $[47] !== t2 || $[48] !== t3 || $[49] !== t4 || $[50] !== t5 || $[51] !== t6 || $[52] !== t7) {
    t17 = <FundingAmount {...t2} method={checkout.method} {...t3} currency={checkout.currency} decimals={checkout.decimals} value={amountDraft.value} presets={checkout.presets} estimate={t4} quoteIndicative={t5} loginForQuote={t6} boundaryFeedback="snackbar" validationError={t7} limits={checkout.displayedLimits} recovery={t10} primaryAction={t11} allowanceBlocked={t12} primaryActionVisible={t13} allowanceExceeded={checkout.limitRecovery.blocked} amountBoundary={checkout.amountBoundary} quoteLoading={checkout.preparingWallet} feeLoading={t14} onAmountChange={checkout.previewAmount} canContinue={t15} pending={checkout.amountLocked} onValueChange={amountDraft.setValue} onChangeMethod={checkout.changeMethod} onContinue={t16} />;
    $[27] = amountDraft.setValue;
    $[28] = amountDraft.value;
    $[29] = checkout.amountBoundary;
    $[30] = checkout.amountLocked;
    $[31] = checkout.changeMethod;
    $[32] = checkout.currency;
    $[33] = checkout.decimals;
    $[34] = checkout.displayedLimits;
    $[35] = checkout.limitRecovery.blocked;
    $[36] = checkout.method;
    $[37] = checkout.preparingWallet;
    $[38] = checkout.presets;
    $[39] = checkout.previewAmount;
    $[40] = t10;
    $[41] = t11;
    $[42] = t12;
    $[43] = t13;
    $[44] = t14;
    $[45] = t15;
    $[46] = t16;
    $[47] = t2;
    $[48] = t3;
    $[49] = t4;
    $[50] = t5;
    $[51] = t6;
    $[52] = t7;
    $[53] = t17;
  } else {
    t17 = $[53];
  }
  let t18;
  if ($[54] !== t1 || $[55] !== t17) {
    t18 = <div hidden={t1}>{t17}</div>;
    $[54] = t1;
    $[55] = t17;
    $[56] = t18;
  } else {
    t18 = $[56];
  }
  return t18;
}